import { Icon } from '@/components/common/icon/icon';
import { DotStatus } from '@/components/common/dots/DotStatus';
import { ActionStatus, CaseClientItem, MessageFilterType } from '@/interfaces';
import { Options } from '@/components/ui/combobox';
import Icons from '@/const/icons';
import { AvatarName } from '@/components/dashboard';
import { OptionsMultiple } from '@/components/ui/comboboxMultiple';
import { getSegmentClientColor } from '@/lib';

const dataDefined: Options[] = [
	{
		label: '0 Tasks',
		value: '0',
		icon: (
			<Icon src={Icons.note} width={18} height={18} className="text-primary" />
		),
	},
	{
		label: '1 Task',
		value: '1',
		icon: (
			<Icon src={Icons.note} width={18} height={18} className="text-primary" />
		),
	},
	{
		label: '+2 Tasks',
		value: '2',
		icon: (
			<Icon src={Icons.note} width={18} height={18} className="text-primary" />
		),
	},
];

const taskClientDefined: Options[] = dataDefined.concat([
	{
		label: 'In Progress',
		value: 'IN_PROGRESS',
		icon: <DotStatus color="green" />,
	},
	{
		label: 'Action Required',
		value: 'ACTION_REQUIRED',
		icon: <DotStatus color="red" />,
	},
	{
		label: 'On Hold',
		value: 'ON_HOLD',
		icon: <DotStatus color="orange" />,
	},
]);

const optionsMessageDefined: Options[] = [
	{
		label: '0 Messages',
		value: '0',
		icon: (
			<Icon src={Icons.note} width={18} height={18} className="text-primary" />
		),
	},
	{
		label: '1 Message',
		value: '1',
		icon: (
			<Icon src={Icons.note} width={18} height={18} className="text-primary" />
		),
	},
	{
		label: '+2 Messages',
		value: '2',
		icon: (
			<Icon src={Icons.note} width={18} height={18} className="text-primary" />
		),
	},
];

export class FiltersInboxAdapter {
	static lawyerTaskFilterAdapter(actionFilterList: ActionStatus[]) {
		const auxList: Options[] = [];
		actionFilterList.forEach((item) =>
			auxList.push({
				label: getNameFormatted(item),
				value: item?.toLocaleLowerCase(),
				icon: getIcon(item),
			})
		);

		return dataDefined.concat(auxList);
	}

	static clientTaskFilterAdapter() {
		return taskClientDefined;
	}

	static clientsFilterAdapter(clients: CaseClientItem[]) {
		return clients.map((client) => ({
			label: (
				<AvatarName
					firstname={client.first_name ?? ''}
					lastname={client.last_name ?? ''}
					photoUrl={client.profile_picture ?? ''}
					size="small"
				/>
			),
			value: client.user_id,
		}));
	}

	static messagesFilterAdapter(caseNameList: MessageFilterType[]) {
		const auxOptions: Options[] = [];
		caseNameList.map((item) =>
			auxOptions.push({
				label: getNameFilter(item),
				value: item,
				icon: (
					<Icon
						src={Icons.sms}
						width={18}
						height={18}
						className="text-primary"
					/>
				),
			})
		);

		const auxData: OptionsMultiple[] = [
			{
				title: 'State of the Messages',
				options: auxOptions,
			},
			{
				title: 'Number of Messages',
				options: optionsMessageDefined,
			},
		];

		return auxData;
	}

	static segmentationFilterAdapter(segmentationList: any[]) {
		const auxList: Options[] = [];
		segmentationList.map((item) =>
			auxList.push({
				label: item.name,
				value: item.id.toString(),
				icon: (
					<Icon
						src={Icons.profile}
						width={18}
						height={18}
						className={`flex-shrink-0 text-[${getSegmentClientColor(
							item.name
						)}]`}
					/>
				),
			})
		);

		return auxList;
	}
}

const getNameFormatted = (value: ActionStatus) => {
	const names: Record<ActionStatus, string> = {
		DUE_SOON: 'Due Soon',
		PAST_DUE: 'Past Due',
		PENDING: 'Pending',
	};
	return names[value];
};

const getIcon = (value: ActionStatus) => {
	const icons: Record<ActionStatus, JSX.Element> = {
		DUE_SOON: <DotStatus color="orange" />,
		PAST_DUE: <DotStatus color="red" />,
		PENDING: <DotStatus color="green" />,
	};
	return icons[value];
};

const getNameFilter = (value: MessageFilterType) => {
	const names: Record<MessageFilterType, string> = {
		NEW_MESSAGES: 'New',
		READ_MESSAGES: 'Read',
		UNREAD_MESSAGES: 'Unread',
	};
	return names[value];
};
